/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCapabilitiesControllerEnvironmentsQueryResponse } from "../../models/incidentAgentController/IncidentCapabilitiesControllerEnvironments";

function getIncidentCapabilitiesControllerEnvironmentsUrl() {
  const res = { method: 'GET', url: `/api/v1/incident-agent/capabilities/environments` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/capabilities/environments}
 */
export async function incidentCapabilitiesControllerEnvironments(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCapabilitiesControllerEnvironmentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentCapabilitiesControllerEnvironmentsUrl().url.toString(), ... requestConfig })  
  return res.data
}